import { render, staticRenderFns } from "./Notifications.vue?vue&type=template&id=6bc582be&scoped=true"
import script from "./Notifications.vue?vue&type=script&lang=js"
export * from "./Notifications.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bc582be",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/print-suite/source/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6bc582be')) {
      api.createRecord('6bc582be', component.options)
    } else {
      api.reload('6bc582be', component.options)
    }
    module.hot.accept("./Notifications.vue?vue&type=template&id=6bc582be&scoped=true", function () {
      api.rerender('6bc582be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/users/Notifications.vue"
export default component.exports